export enum ExportFormatsEnum {
    ALL = 'all',
    EXCELL = 'merchant-statement-excel',
    CSV = 'merchant-statement-csv',
    POSCSV = 'pos-transactionsv2-csv',
    POSAMEXCSV = 'pos-amex-transactions-csv',
    ECOMCSV = 'ecom-transactions-csv'
}
